import { Card, CardContent } from '@/components/ui/card';
import { SectionHeading, EmptySection, Field, TagList } from './shared';

interface Props {
  data: any | null;
}

const BEAUFORT_LABELS: Record<number, string> = {
  0: '0 — Calm',
  1: '1 — Light air',
  2: '2 — Light breeze',
  3: '3 — Gentle breeze',
  4: '4 — Moderate breeze',
  5: '5 — Fresh breeze',
  6: '6 — Strong breeze',
  7: '7 — Near gale',
  8: '8 — Gale',
  9: '9 — Strong gale',
  10: '10 — Storm',
  11: '11 — Violent storm',
  12: '12 — Hurricane',
};

export default function DailySetupSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-daily-setup" title="Daily Setup" />
      {!data ? (
        <EmptySection name="daily setup data" />
      ) : (
        <Card className="mt-2">
          <CardContent className="grid grid-cols-2 gap-4 pt-4 sm:grid-cols-3 lg:grid-cols-4">
            <Field label="Weather Condition" value={data.weather_condition} />
            <Field
              label="Wind Speed"
              value={data.wind_speed_knots != null ? `${data.wind_speed_knots} knots` : null}
            />
            <Field
              label="Visibility"
              value={data.visibility_nm != null ? `${data.visibility_nm} NM` : null}
            />
            <Field
              label="Sea State"
              value={
                data.sea_state_beaufort != null
                  ? BEAUFORT_LABELS[data.sea_state_beaufort] ?? `Beaufort ${data.sea_state_beaufort}`
                  : null
              }
            />
            <Field
              label="Temperature"
              value={data.temperature_celsius != null ? `${data.temperature_celsius} °F` : null}
            />
            <Field label="Site Conditions" value={data.site_conditions_notes} />
            <div className="col-span-full">
              <Field label="Rig Activity Codes" value={<TagList tags={data.rig_activity_codes} />} />
            </div>
          </CardContent>
        </Card>
      )}
    </section>
  );
}
